import { enumDashStyle, enumElementBorderStyle, enumFillMode } from "../constants";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_AdjustLineWidth } from "./XML_AdjustLineWidth";
import { XML_ShiftRect } from "./XML_ShiftRect";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_Param4 } from "./XML_Param4";
import { RoundTo3 } from "./RoundTo3";

export function XML_RenderChartBoxPPT(
  bounds,
  outerBounds,
  boxShape,
  fillMode,
  fillColor,
  borderStyle,
  borderThickness,
  borderColor,
  dashStyle,
  shadow,
  drawElement,
  theLayer,
  backColor
) {
  XML_ShiftRect(bounds, drawElement, theLayer);
  XML_ShiftRect(outerBounds, drawElement, theLayer);
  borderThickness = XML_AdjustLineWidth(borderThickness, drawElement, theLayer);

  bounds.fTop = drawElement.ConvertY(bounds.fTop);
  bounds.fBottom = drawElement.ConvertY(bounds.fBottom);

  outerBounds.fTop = drawElement.ConvertY(outerBounds.fTop);
  outerBounds.fBottom = drawElement.ConvertY(outerBounds.fBottom);

  var shapeString = "";
  //TODO: BorderStyles
  switch (boxShape) {
    case 0:
      shapeString = "rec";
      break;
    case 1:
      shapeString = "rrec";
      break;
    case 2:
      shapeString = "snrec";
      break;
    case 3:
      shapeString = "rcrec";
      break;
    default:
      shapeString = "";
      break;
  }
  var double = borderStyle == enumElementBorderStyle.doubleBorder;

  if (double && shapeString != "") {
    XML_Cmd4(
      shapeString,
      RoundTo3(outerBounds.fLeft),
      RoundTo3(outerBounds.fTop),
      RoundTo3(outerBounds.fRight - outerBounds.fLeft),
      RoundTo3(outerBounds.fBottom - outerBounds.fTop),
      drawElement
    );
    XML_Param4("p", fillColor, borderColor, 1, dashStyle, drawElement);
  }
  //Shape, origin, and size
  XML_Cmd4(
    shapeString,
    RoundTo3(bounds.fLeft),
    RoundTo3(bounds.fTop),
    RoundTo3(bounds.fRight - bounds.fLeft),
    RoundTo3(bounds.fBottom - bounds.fTop),
    drawElement
  );
  //Fill color, border color, border thickness, border dash
  if (fillMode === enumFillMode.noFill) {
    //transparency flag
    fillColor = 0;
  }

  var innerDashStyle = double ? enumDashStyle.nodash : dashStyle;
  XML_Param4("p", fillColor, borderColor, borderThickness, innerDashStyle, drawElement);

  if (fillMode === enumFillMode.linearGradientDown) {
    //gradients
    XML_AddSingle(backColor, "grd", drawElement);
  }

  if (shadow) {
    XML_AddSingle(1, "shdw", drawElement);
  }
}
